module.exports = __webpack_public_path__ + "static/media/signal-alt-slash.587cad50.svg";